import React from 'react';
import './Header.css';
import logo from '../../assets/img/logo.png';
import Login from './Login/Login';
import User from './User/User';

let Header = props => {
    return (
        <header>
            <div className="logo">
                <img src={logo} alt="Fifa World Cup 2018" />
                <h3>World Cup Contest 2018</h3>
            </div>
        
            <div className="rules">
                <h2>Contest Rules</h2>
                <ul>
                    <li className="icon-circle-check">
                        <span>You're sponsoring or running a contest or sweepstakes.</span>
                    </li>
                    <li className="icon-circle-check">
                        <span>You want to clearly define rules, regulations, and submission requirements so everything's legal.</span>
                    </li>
                    <li className="icon-circle-check">
                        <span>You want to designate dates, deadlines, and methods of entry so it's crystal clear for contestants.</span>
                    </li>
                </ul>
            </div>
            {
                props.user.name?
                    <User user={props.user} />:
                    <Login getLogin={props.getLogin} />
            }
        </header>
    );
};

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx